import reducer from './reducer';
import * as actions from './actions';
import * as selectors from './selectors';
import { BERG_STORE } from '@constants';

const {
  data: { createReduxStore, register },
} = wp;

if (!window.__reduxStoreRegistered__) {
  const store = createReduxStore(BERG_STORE, {
    reducer,
    actions,
    selectors,
  });

  register(store);

  // Set window variable to indicate store registration
  window.__reduxStoreRegistered__ = true;
}
